<script setup lang="ts">
import { useLoadingStore } from '../../stores';
import LoadingIcon from './LoadingIcon.vue';

const loading = useLoadingStore()
</script>

<template>
    <div v-if="loading.isLoading" class="fixed bg-black/30 z-[100] inset-0 flex items-center justify-center">
        <LoadingIcon />
    </div>
</template>